/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const guidCreatedOrUpdatedEntityModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор")
    })